import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { CONSTANTS } from "../constants/constants";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class PassageReportService {
  constructor(private readonly httpclient: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  getAllPassageReport(data: { pageNumber: number; pageSize: number }) {
    let url =
      environment.BASE_API_URL + CONSTANTS.API.PASSAGE.GET_PASSAGE_REPORT;
    return this.httpclient.post<any>(url, data, this.headers);
  }

  dowloadPassageReport(
    vesselId: number,
    fromDate: any,
    toDate: any,
    isReview: boolean
  ) {
    console.log(fromDate);
    console.log(toDate);
    let url =
      environment.BASE_API_URL +
      CONSTANTS.API.DOWNLOAD.PASSAGE_REPORT +
      "?vesselId=" +
      vesselId +
      "&from=" +
      fromDate +
      "&to=" +
      toDate +
      "&isReview=" +
      isReview;
    return this.httpclient.get<any>(url, { responseType: "blob" as "json" });
  }
}
